module.exports = __webpack_public_path__ + "img/Price Tag.3f7df58.png";